<template>
  <div class="common-box">
    <button ref="play" @click="startplay" v-show="false">播放</button>
    <button ref="stop" @click="pausePlay" v-show="false">暂停</button>
    <div
      id="container1"
      ref="container1"
      style="width: 100%; height: 250px"
      :style="{ height: chartHeight - 95 + 'px' }"
    ></div>
    <!-- 警报1 -->
    <audio controls="controls" hidden src="@/assets/warning.mp3" ref="audio" loop></audio>
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import {
    getSugerbyId,
    loopTreatments,
    getAllTempArry,
    getEvent,
    getDeviceData,
    getAolXueyaData,
    getAolXuetangData,
    getPenInfo,
  } from '@/api/userServices'
  import { Mix, G2 } from '@antv/g2plot'
  import yds from '@/static/pic/loopYDS.png'
  import { loopHistory } from '@/api/relationship'
  import { mapState, mapActions, mapMutations } from 'vuex'
  import {
    DEFAULT_INSULIN_AGE_MODE,
    getInsulinEffectDurationHours,
    getInsulinTypeName,
    getLatestInsulinEffectEndTimestamp,
    getRecordInsulinEffectDurationHours,
    percentEffectRemainingForRecord,
  } from '@/utils/loopInsulinModel'
  const G = G2.getEngine('canvas')
  export default {
    props: {
      btnNum: {
        default: '',
      },
      isIndex: {
        default: '',
      },
      isAlarm: {
        default: '',
      },
    },
    data() {
      return {
        timer: null, // 5分钟一次的定时器
        timerNum: 0,
        mixPlot: null,
        chartData: [],
        userId: JSON.parse(localStorage.getItem('appuser')).id,
        chartTime: 0.875,
        trend: '',
        sliderEnd: 1,
        sliderStart: 0,
        isDown: false,
        startX: '',
        endX: '',
        moveX: '',
        boxWidth: '',
        moveRate: '',
        downLeft: '',
        downRight: '',
        isHaveSugar: true,
        targetHigh: '',
        targetLow: '',
        allTempArray: [], // 基础率组合数组
        loopRemote: JSON.parse(localStorage.getItem('appuser')).loopRemote,
        chartHeight: '',
        // 下面是socket相关参数
        socketId: JSON.parse(localStorage.getItem('appuser')).id,
        maxTemp: 1.6,
        insRecordList: [],
        actIobList: [],
        maxIob: 0,
        insType: '',
        insulinAgeMode: DEFAULT_INSULIN_AGE_MODE,
        duration: getInsulinEffectDurationHours(),
        targetHigh: '',
        targetLow: '',
      }
    },
    created() {
      this.targetHigh = JSON.parse(localStorage.getItem('appuser')).targetHigh || '10'
      this.targetLow = JSON.parse(localStorage.getItem('appuser')).targetLow || '3.9'
    },
    mounted() {
      this.timer = setInterval(() => {
        this.timerNum++
        this.getData().then(() => {
          this.getAllEvent().then(() => {
            this.mixPlot.destroy()
            this.getChart()
          })
        })
      }, 5 * 60 * 1000)

      this.getData().then(() => {
        this.getAllEvent().then(() => {
          this.getChart()
        })
      })
      this.minTime = this.minTime3
      this.tickInterval = 30 * 60 * 1000

      //定义回调函数
      this.$ws.type1 = debounce(this.getAllData, 2000)
      this.$ws.type20 = debounce(this.getAllData, 2000)
      this.$ws.type21 = debounce(this.getAllData, 2000)
      this.$ws.type22 = debounce(this.getAllData, 2000)

      this.chartHeight = window.innerHeight
    },
    beforeDestroy() {
      this.$ws.type1 = null
      this.$ws.type20 = null
      this.$ws.type21 = null
      this.$ws.type22 = null
      clearInterval(this.timer) // 停止定时
    },
    methods: {
      // 根据chatTime不同，来截取3小时、6小时。。。的数组数据
      filterRecentDataByChatTime(arr, chatTime) {
        // 1. 定义 chatTime 与小时数的映射关系（保持原有逻辑不变）
        const timeMap = {
          0.875: 3, // 3小时
          0.75: 6, // 6小时
          0.5: 12, // 12小时
          0: 24, // 24小时
        }

        // 2. 获取目标小时数，默认3小时（兜底逻辑）
        const targetHours = timeMap[chatTime] || 3

        // 3. 计算时间阈值：当前时间往前推 targetHours 小时（毫秒级时间戳）
        const nowTimestamp = Date.now()
        const thresholdTimestamp = nowTimestamp - targetHours * 60 * 60 * 1000

        // 4. 过滤数组：仅保留 content.time 在阈值内的数据
        return arr.filter(item => {
          try {
            // 仅读取 content.time，无则直接过滤
            const sendTimeStamp = item?.content?.time
            // 校验：time存在、是数字、且大于0（有效时间戳）
            if (sendTimeStamp === undefined || sendTimeStamp === null || isNaN(sendTimeStamp) || sendTimeStamp <= 0) {
              return false
            }

            // 关键：Unix时间戳是秒级，需转为毫秒级再对比
            const sendTimeMs = sendTimeStamp * 1000
            // 时间戳有效 且 大于等于阈值 → 保留
            return sendTimeMs >= thresholdTimestamp
          } catch (error) {
            // 异常情况（如content不存在）→ 过滤
            return false
          }
        })
      },
      getAolDataList(res) {
        const data = res && res.data ? res.data.data : []
        return Array.isArray(data) ? data : []
      },
      safeJsonParse(value) {
        if (!value || typeof value !== 'string') return value
        try {
          return JSON.parse(value)
        } catch (e) {
          return value
        }
      },
      mergeDefinedFields(...sources) {
        return sources.reduce((result, current) => {
          if (!current || typeof current !== 'object') return result
          Object.keys(current).forEach(key => {
            const value = current[key]
            if (value !== undefined && value !== null && value !== '') {
              result[key] = value
            }
          })
          return result
        }, {})
      },
      normalizeTimestamp(value) {
        if (!value) return 0
        if (typeof value === 'number') {
          return value > 9999999999 ? value : value * 1000
        }
        if (/^\d+$/.test(String(value))) {
          const num = Number(value)
          return num > 9999999999 ? num : num * 1000
        }
        const parsed = new Date(String(value).replace(/-/g, '/')).getTime()
        return Number.isNaN(parsed) ? 0 : parsed
      },
      normalizeAolDeviceItem(item) {
        const parsedItem = this.safeJsonParse(item)
        const source = parsedItem && typeof parsedItem === 'object' ? parsedItem : {}
        const parsedData = this.safeJsonParse(source.data)
        const parsedContent = this.safeJsonParse(source.content)
        const parsedJson = this.safeJsonParse(source.json)
        return this.mergeDefinedFields(
          source,
          parsedData && typeof parsedData === 'object' ? parsedData : {},
          parsedContent && typeof parsedContent === 'object' ? parsedContent : {},
          parsedJson && typeof parsedJson === 'object' ? parsedJson : {}
        )
      },
      isWithinRecentRange(value, chatTime) {
        const timeMs = this.normalizeTimestamp(value)
        if (!timeMs) return false
        const timeMap = {
          0.875: 3,
          0.75: 6,
          0.5: 12,
          0: 24,
        }
        const targetHours = timeMap[chatTime] || 24
        return timeMs >= Date.now() - targetHours * 60 * 60 * 1000 && timeMs <= Date.now()
      },
      formatAolXueyaChartData(list, chatTime) {
        return (list || [])
          .filter(item => this.isWithinRecentRange(item && item.time, chatTime))
          .map(item => {
            const timeMs = this.normalizeTimestamp(item.time)
            const normalizedItem = this.normalizeAolDeviceItem(item)
            const createTime = this.$moment(timeMs).format('YYYY-MM-DD HH:mm:ss')
            return {
              create_time: createTime,
              tooltip_time: createTime.substring(11, 16),
              type: 'aolXy',
              v: 17,
              data1: normalizedItem.data1,
              data2: normalizedItem.data2,
              data3: normalizedItem.data3,
            }
          })
      },
      formatAolXuetangChartData(list, chatTime) {
        return (list || [])
          .filter(item => this.isWithinRecentRange(item && item.time, chatTime))
          .map(item => {
            const timeMs = this.normalizeTimestamp(item.time)
            const normalizedItem = this.normalizeAolDeviceItem(item)
            const createTime = this.$moment(timeMs).format('YYYY-MM-DD HH:mm:ss')
            const value = Number(normalizedItem.data3) / 18
            return {
              create_time: createTime,
              tooltip_time: createTime.substring(11, 16),
              type: 'aolXt',
              v: 19,
              value: Number.isFinite(value) ? Number(value.toFixed(1)) : '--',
            }
          })
      },
      addAolDeviceData(datePrefix) {
        return Promise.all([
          getAolXuetangData({ uid: this.userId }),
          getAolXueyaData({ uid: this.userId }),
        ]).then(([sugarRes, bloodPressureRes]) => {
          this.formatAolXueyaChartData(this.getAolDataList(bloodPressureRes), 0).forEach(item => {
            this.chartData.push(item)
          })
          this.formatAolXuetangChartData(this.getAolDataList(sugarRes), 0).forEach(item => {
            this.chartData.push(item)
          })
        }).catch(() => {
          return []
        })
      },
      startplay() {
        // const audio = this.$refs.audio
        this.$refs.audio.play()

        setTimeout(() => {
          this.pausePlay()
        }, 10000)
        // audio.addEventListener('timeupdate', () => {
        //   if (audio.currentTime >= 10) {
        //     this.pausePlay() // 播放到10秒时暂停音频
        //     audio.currentTime = 0 // 可选：重置到音频开头
        //     console.log('音频播放了10秒钟，已停止')
        //   }
        // })
      },
      pausePlay() {
        //暂停播放
        this.$refs.audio.pause() //暂停
        // clearInterval(this.timer)
        // this.timer = null
      },
      // 格式化时间
      formatTime(timestamp) {
        const date = new Date(timestamp)
        return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss') // 返回 'YYYY-MM-DDTHH:mm:ss' 格式
      },
      // 获取当前时间时间戳
      parseTime(time) {
        return new Date(time).getTime()
      },
      // 数组去重
      getTooltipTypeName(item) {
        let loopType = ''
        try {
          loopType = item && item.json ? JSON.parse(item.json).type : ''
        } catch (e) {}
        const loopMap = {
          1: '关闭闭环',
          2: '开启闭环',
          3: '覆盖方波',
          4: '取消方波',
          5: '添加碳水',
          6: '大剂量',
          7: '临时基础率',
          8: '取消临时',
        }
        const typeMap = {
          sugar: '血糖',
          zx: '指尖血',
          kfy: '口服药',
          xy: '血压',
          aolXy: '爱奥乐血压',
          xz: '血脂',
          BF: '血脂',
          ns: '尿酸',
          UA: '尿酸',
          aolXt: '爱奥乐血糖',
          GLU: '血糖',
          KET: '血酮',
          ts: '碳水',
          yds: '胰岛素',
          yd: '运动',
          'Correction Bolus': '胰岛素',
          'Meal Bolus': '胰岛素',
          'Combo Bolus': '扩展胰岛素',
          'Carb Correction': '碳水',
          'Temporary Override': '覆盖方波',
          'Temporary Target': '覆盖方波',
          'Suspend Pump': '泵',
          'OpenAPS Offline': '泵',
        }
        return loopMap[loopType] || typeMap[item && item.type] || typeMap[item && item.eventType] || '其他'
      },
      renderPointTooltip(title, data) {
        const item = data && data[0] && data[0].data
        if (!title || !item) return ''
        const time = item.tooltip_time || (item.create_time ? this.$moment(item.create_time).format('HH:mm:ss') : title)
        const type = this.getTooltipTypeName(item)
        if (item.type === 'sugar') {
          const tempValue = item.tempValue ? item.tempValue.toFixed(2) : item.tempValue == 0 ? 0 : '无'
          const iob = item.iob ? (item.iob <= 0.04 ? 0 : item.iob) : 0
          return `<div style="padding:2px;">
                        <div style="margin-bottom:2px;font-size:10px;font-weight: 700;"> ${time}</div>
                        <div style="font-size:10px;margin-bottom:2px;">${type}:${(item.v * 1).toFixed(1)}</div>
                        <div style="margin-bottom:2px;font-size:10px"> 基础率:${tempValue}</div>
                        <div style="font-size:10px;margin-bottom:2px;">活性胰岛素:${iob}</div>
                      </div>`
        }
        const hasValue = value => value !== undefined && value !== null && String(value).trim() !== '' && value !== '--'
        const detailRow = text => `<div style="margin-bottom:4px;font-size:14px;">${text}</div>`
        if (['zx', 'kfy', 'xy', 'xz', 'ns', 'ts', 'yds', 'yd'].includes(item.type)) {
          let details = []
          switch (item.type) {
            case 'zx':
              details = [hasValue(item.eventValue) ? detailRow(`场景：${item.eventValue}`) : '', detailRow(`指血指数：${item.way}mmol/L`)]
              break
            case 'kfy':
              details = [detailRow(`药名：${item.way}`), hasValue(item.eventValue) ? detailRow(`用药量：${item.eventValue}mg`) : '']
              break
            case 'xy':
              details = [
                detailRow(`收缩压：${item.way}mmHg`),
                detailRow(`舒张压：${item.eventValue}mmHg`),
                hasValue(item.scene) ? detailRow(`心率：${item.scene}次/分`) : '',
              ]
              break
            case 'xz':
              details = [
                detailRow(`总胆固醇：${item.way}mmol/L`),
                detailRow(`甘油三酯：${item.eventValue}mmol/L`),
                hasValue(item.scene) ? detailRow(`低密度脂蛋白：${item.scene}mmol/L`) : '',
              ]
              break
            case 'ns':
              details = [detailRow(`尿酸值：${item.way}umol/L`)]
              break
            case 'ts':
              details = [detailRow(`${item.eventValue}`), detailRow(`碳水化合物：${item.way}g`)]
              break
            case 'yds':
              details = [
                detailRow(`注射剂量：${item.way}U`),
                hasValue(item.scene) ? detailRow(`注射时段：${item.scene}`) : '',
                hasValue(item.eventValue) ? detailRow(`胰岛素名称：${item.eventValue}`) : '',
              ]
              break
            case 'yd':
              details = [
                detailRow(`运动项目：${item.way}`),
                hasValue(item.scene) ? detailRow(`运动时长：${item.scene}分钟`) : '',
                hasValue(item.eventValue) ? detailRow(`消耗：${item.eventValue}kcal`) : '',
              ]
              break
          }
          return `<div style="padding:4px;">
                    <div style="font-size:14px;font-weight:700;margin-bottom:4px;">${type}</div>
                    <div style="margin-bottom:4px;font-size:14px;">${time}</div>
                    ${details.join('')}
                  </div>`
        }
        if (item.type === 'Correction Bolus') {
          const insulin = item.insulin ? (item.insulin * 1).toFixed(2) : '无'
          return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${time}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 剂量:${insulin}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 名称:${item.insulinType || '无'}</div>
                      </div>`
        }
        if (item.type === 'Combo Bolus') {
          const insulin = item.insulin ? (item.insulin * 1).toFixed(2) : '无'
          return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${time}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 剂量:${insulin}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 持续时间:${item.duration || '无'}分钟</div>
                      </div>`
        }
        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div> ${time}</div>
                      </div>`
      },
      sortInsRecordList() {
        this.insRecordList.sort((a, b) => this.$moment(a.createTime).valueOf() - this.$moment(b.createTime).valueOf())
      },
      iobFraction(t, item) {
        return percentEffectRemainingForRecord(t * 60, item, this.insType, this.insulinAgeMode)
      },
      getIOBChartData() {
        const intervalMinutes = 5
        const result = []
        const now = this.$moment()
        this.insRecordList = this.insRecordList.filter(item => now.diff(this.$moment(item.createTime), 'hours') <= 29)
        if (!this.insRecordList.length) return result
        const start = this.$moment(this.insRecordList[0].createTime)
        const end = this.$moment(
          getLatestInsulinEffectEndTimestamp(this.insRecordList, this.insType, this.insulinAgeMode)
        )
        for (let time = start.clone(); time.isSameOrBefore(end); time.add(intervalMinutes, 'minutes')) {
          if (time.isAfter(now)) continue
          let total = 0
          this.insRecordList.forEach(item => {
            const dose = Number(item.realInsulin)
            const injTime = this.$moment(item.createTime)
            const deltaHours = time.diff(injTime, 'minutes') / 60
            const recordDuration = getRecordInsulinEffectDurationHours(item, this.insType, this.insulinAgeMode)
            if (Number.isFinite(dose) && deltaHours >= 0 && deltaHours <= recordDuration) {
              total += dose * this.iobFraction(deltaHours, item)
            }
          })
          const value = Number(total.toFixed(2))
          if (!value) continue
          result.push({
            create_time: time.format('YYYY-MM-DD HH:mm:ss'),
            tooltip_time: time.format('HH:mm'),
            value,
            type: 'iob',
          })
        }
        return result
      },
      fillChartDataIob() {
        if (!this.actIobList.length) return

        this.chartData.forEach(item => {
          if (!item || !item.create_time) return

          const time = this.$moment(item.create_time).valueOf()
          this.actIobList.forEach((iob, i) => {
            const preTime = this.$moment(iob.create_time).valueOf()
            const nextTime = this.actIobList[i + 1]
              ? this.$moment(this.actIobList[i + 1].create_time).valueOf()
              : null
            if ((preTime <= time && nextTime >= time) || (preTime <= time && !nextTime)) {
              item.iob = iob.value
              item.iobType = iob.type
            }
          })
        })
      },
      loadPenInsulinRecords() {
        return getPenInfo({ uid: this.userId })
          .then(({ data }) => {
            const penInfo = data && data.data && data.data[0]
            const peizhi = penInfo && penInfo.peizhi ? JSON.parse(penInfo.peizhi) : {}
            this.insType = peizhi.insType
            this.insulinAgeMode = peizhi.insulinAgeMode || DEFAULT_INSULIN_AGE_MODE
            this.duration = getInsulinEffectDurationHours(this.insType, this.insulinAgeMode)
            const records = penInfo && penInfo.jilu
            this.insRecordList = Array.isArray(records) ? records : records ? JSON.parse(records) : []
            this.sortInsRecordList()
            this.actIobList = this.getIOBChartData()
            this.maxIob = this.actIobList.length ? Math.max(...this.actIobList.map(item => item.value)) : 0
          })
          .catch(() => {
            this.insRecordList = []
            this.actIobList = []
            this.maxIob = 0
          })
      },
      buildPenInsulinEvents() {
        if (!Array.isArray(this.insRecordList) || !this.insRecordList.length) return []
        return this.insRecordList
          .map(item => {
            const dose = Number(item && item.realInsulin)
            const time = this.$moment(item && item.createTime)
            if (!Number.isFinite(dose) || dose <= 0 || !time.isValid()) return null
            if (!this.isWithinRecentRange(time.valueOf(), this.chartTime)) return null
            const createTime = time.format('YYYY-MM-DD HH:mm:ss')
            return {
              ...item,
              createTime,
              create_time: createTime,
              tooltip_time: createTime.substring(11, 16),
              type: 'Correction Bolus',
              eventType: 'Correction Bolus',
              insulin: dose.toFixed(2),
              insulinType:
                getInsulinTypeName(item.insulinType) === '--'
                  ? item.medicalType || '胰岛素笔'
                  : getInsulinTypeName(item.insulinType),
              notes: item.notes || '',
              v: 0,
            }
          })
          .filter(Boolean)
      },
      removeDuplicates(arr, key) {
        const seen = new Set()
        return arr.filter(item => {
          const val = item[key]
          if (seen.has(val)) {
            return false
          } else {
            seen.add(val)
            return true
          }
        })
      },
      // 20秒内如果胰岛素相同，则去重
      deduplicateData(data) {
        // 1. 复制并按时间戳升序排序
        const sortedData = [...data].sort((a, b) => new Date(a.create_time) - new Date(b.create_time))

        // 2. 用于记录某 insulin 值上一次出现的时间戳
        const lastOccurrence = {}

        // 3. 用于存放结果
        const result = []

        for (let item of sortedData) {
          const { create_time, insulin, type } = item

          // 如果没有 insulin 字段，直接保留
          if (type !== 'Correction Bolus') {
            result.push(item)
            continue
          }

          // 判断是否在 20 秒内重复
          if (lastOccurrence.hasOwnProperty(insulin) && new Date(create_time) - lastOccurrence[insulin] < 20 * 1000) {
            // 如果是 20 秒内出现相同 insulin，则跳过
            continue
          } else {
            // 否则保留该条数据并更新记录
            result.push(item)
            lastOccurrence[insulin] = new Date(create_time)
          }
        }
        return result
      },
      // websoket来信息调用
      getAllData() {
        this.getData().then(() => {
          this.getAllEvent()
        })
      },
      // 血糖事件集合数组按照事件排序
      sortTime(obj) {
        obj.sort((a, b) => {
          let t1 = new Date(Date.parse(a.create_time.replace(/-/g, '/')))
          let t2 = new Date(Date.parse(b.create_time.replace(/-/g, '/')))
          return t1.getTime() - t2.getTime()
        })
        return obj
      },
      // 获取所有事件
      async getAllEvent() {
        await this.loadPenInsulinRecords()
        return new Promise(resolve => {
          this.eventArr = []
          // 获取基础率和临时基础率组合数组
          const tempParams = {
            uid: this.userId,
            end: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
            start: this.$moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
            type: this.loopRemote,
          }
          let params = {
            uid: this.userId,
            create_time: this.$moment().add(1, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
            type: this.loopRemote,
          }
          loopHistory(params).then(res => {
            this.$emit('loopInfo', res)
          })
          getAllTempArry(tempParams).then(res => {
            // 基础率组合数组
            this.allTempArray = res ? (res.data.data.length ? res.data.data : []) : []
            this.maxTemp = Math.max(...this.allTempArray.map(item => item.value))
            // 获取 ns 事件
            const nsParams = {
              uid: this.userId,
              end: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
              start: this.$moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
              type: this.loopRemote,
            }
            loopTreatments(nsParams).then(({ data }) => {
              if (data.treatments && data.treatments.length) {
                data.treatments.forEach(item => {
                  if (item.eventType === 'Temp Basal') {
                  }
                  // 胰岛素
                  else if (item.eventType === 'Correction Bolus' || item.eventType === 'Meal Bolus') {
                    if (item.insulin) {
                      item.createTime = item.create_time
                      item.v = 0
                      item.type = 'Correction Bolus'
                      item.insulin = (item.insulin * 1).toFixed(2)
                      this.eventArr.push(item) // 添加ns事件---胰岛素
                    }
                  } else if (item.eventType === 'Combo Bolus') {
                    if (item.enteredinsulin) {
                      item.createTime = item.create_time
                      item.v = 0
                      item.type = 'Combo Bolus'
                      item.insulin = (item.enteredinsulin * 1).toFixed(2)
                      this.eventArr.push(item) // 添加ns事件---胰岛素
                    }
                  }
                  // 碳水分组
                  else if (item.eventType === 'Carb Correction') {
                    item.createTime = item.create_time
                    item.v = -1
                    item.type = item.eventType
                    this.eventArr.push(item) // 添加ns事件---碳水
                  }
                  // 覆盖方波分组
                  else if (
                    this.loopRemote == 'loop'
                      ? item.eventType === 'Temporary Override' && item.duration
                      : item.eventType === 'Temporary Target'
                  ) {
                    item.createTime = item.create_time
                    item.v = -2
                    item.type = 'Temporary Override'
                    item.duration = item.durationInMilliseconds
                      ? (item.durationInMilliseconds / 1000 / 60).toFixed(1)
                      : (item.duration * 1).toFixed(1)
                    this.eventArr.push(item) // 添加ns事件---覆盖方波
                  }
                  // 泵分组
                  else if (
                    this.loopRemote == 'loop' ? item.eventType === 'Suspend Pump' : item.eventType === 'OpenAPS Offline'
                  ) {
                    item.createTime = item.create_time
                    item.v = -2
                    item.type = 'Suspend Pump'
                    this.eventArr.push(item)
                  }
                  // 其他
                  // else {
                  //   item.createTime = item.create_time;
                  //   item.v = -2;
                  //   item.type = item.eventType;
                  //   this.eventArr.push(item);
                  // }
                })
              }
              this.eventArr = this.deduplicateData(this.eventArr.concat(this.buildPenInsulinEvents()))

              this.eventArr.forEach(event => {
                event.create_time = event.createTime
                event.type = event.type
                event.tooltip_time = event.createTime.substring(11, 16)
                event.v = 1

                this.chartData.push(event)
              })
              this.sortTime(this.chartData)
              let v2 = ''
              let v1 = ''
              // 就这里面没处理好，导致y轴错乱
              this.chartData.forEach((item, index) => {
                // 把时间、血糖合并数组里的血糖先挑出来处理
                if (item.type != 'sugar') {
                  if (item.type == 'Temporary Override') {
                    item.v = 18.5
                  } else {
                    for (let i = index - 1; i >= 0; i--) {
                      if (this.chartData[i].type == 'sugar') {
                        v1 = this.chartData[i].v
                        break
                      }
                    }

                    for (let i = index + 1; i <= this.chartData.length - 1; i++) {
                      if (this.chartData[i].type == 'sugar') {
                        v2 = this.chartData[i].v
                        break
                      }
                    }
                    if (v1 && v2) {
                      item.v = (v1 + v2) / 2
                    } else if (v1) {
                      item.v = v1
                    } else if (v2) {
                      item.v = v2
                    }
                  }
                }
                // 把每个点（包括事件，否则可能会图表错乱）都复值前一个基础率
                const time = this.$moment(item.create_time).valueOf()

                if (data.treatments && data.treatments.length) {
                  this.allTempArray.forEach((temp, i) => {
                    const preTime = this.$moment(temp.timestamp).valueOf()
                    const nextTime = this.allTempArray[i + 1]
                      ? this.$moment(this.allTempArray[i + 1].timestamp).valueOf()
                      : null
                    if ((preTime <= time && nextTime >= time) || (preTime <= time && !nextTime)) {
                      item.tempValue = temp.value
                      item.tempType = temp.type
                    }
                  })
                }
                if (this.actIobList.length) {
                  this.actIobList.forEach((iob, i) => {
                    const preTime = this.$moment(iob.create_time).valueOf()
                    const nextTime = this.actIobList[i + 1]
                      ? this.$moment(this.actIobList[i + 1].create_time).valueOf()
                      : null
                    if ((preTime <= time && nextTime >= time) || (preTime <= time && !nextTime)) {
                      item.iob = iob.value
                      item.iobType = iob.type
                    }
                  })
                }
              })
              // 获取糖仁云事件
              const params = {
                id: this.userId,
                end: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                start: this.$moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
              }
              getEvent(params).then(({ data }) => {
                data.data.forEach(trEvent => {
                  if (trEvent.type === 'cx') {
                    const dose = Number(trEvent.way)
                    const createTime = trEvent.createTime
                    if (Number.isFinite(dose) && dose > 0 && createTime) {
                      const eventTime = this.$moment(createTime).valueOf()
                      const sugarList = this.chartData
                        .filter(item => item.type === 'sugar' && this.$moment(item.create_time).isValid())
                        .sort((a, b) => this.$moment(a.create_time).valueOf() - this.$moment(b.create_time).valueOf())
                      const prevSugar = [...sugarList]
                        .reverse()
                        .find(item => this.$moment(item.create_time).valueOf() <= eventTime)
                      const nextSugar = sugarList.find(item => this.$moment(item.create_time).valueOf() >= eventTime)
                      this.chartData.push({
                        ...trEvent,
                        createTime,
                        create_time: createTime,
                        tooltip_time: createTime.substring(11, 16),
                        type: 'Correction Bolus',
                        eventType: 'Correction Bolus',
                        insulin: dose.toFixed(2),
                        insulinType: '长效胰岛素',
                        notes: '',
                        isLongActingInsulin: true,
                        v:
                          prevSugar && nextSugar
                            ? (prevSugar.v + nextSugar.v) / 2
                            : prevSugar
                            ? prevSugar.v
                            : nextSugar
                            ? nextSugar.v
                            : 24,
                      })
                    }
                  } else {
                    trEvent.create_time = trEvent.createTime
                    trEvent.v = 24

                    this.chartData.push(trEvent)
                  }
                })
                // 获取生化 / 爱奥乐血压 / 爱奥乐血糖设备信息
                Promise.all([
                  getDeviceData({
                    uid: JSON.parse(localStorage.getItem('appuser')).id,
                  }),
                  getAolXueyaData({
                    uid: JSON.parse(localStorage.getItem('appuser')).id,
                  }),
                  getAolXuetangData({
                    uid: JSON.parse(localStorage.getItem('appuser')).id,
                  }),
                ])
                  .then(([deviceRes, aolXyRes, aolXtRes]) => {
                    const deviceDataList = this.filterRecentDataByChatTime(deviceRes.data.data, 0)
                    deviceDataList.forEach(item => {
                      if (item.content.type == 'BF') {
                        this.chartData.push({
                          create_time: this.$moment(item.content.time * 1000).format('YYYY-MM-DD HH:mm:ss'),
                          type: item.content.type,
                          v:
                            item.content.type == 'GLU'
                              ? 19
                              : item.content.type == 'UA'
                              ? 21
                              : item.content.type == 'BF'
                              ? 23
                              : 25,
                          TC: item.content.TC,
                          TG: item.content.TG,
                          HDL: item.content.HDL,
                          LDL: item.content.LDL,
                        })
                      } else {
                        this.chartData.push({
                          create_time: this.$moment(item.content.time * 1000).format('YYYY-MM-DD HH:mm:ss'),
                          type: item.content.type,
                          v:
                            item.content.type == 'GLU'
                              ? 19
                              : item.content.type == 'UA'
                              ? 21
                              : item.content.type == 'BF'
                              ? 23
                              : 25,
                          value: item.content.value,
                        })
                      }
                    })
                    this.formatAolXueyaChartData((aolXyRes.data && aolXyRes.data.data) || []).forEach(item => {
                      this.chartData.push(item)
                    })
                    this.formatAolXuetangChartData((aolXtRes.data && aolXtRes.data.data) || []).forEach(item => {
                      this.chartData.push(item)
                    })
                    this.fillChartDataIob()
                    this.sortTime(this.chartData)
                    setTimeout(() => {
                      if (this.mixPlot) {
                        this.mixPlot.changeData(this.chartData)
                      }
                      resolve()
                    }, 300)
                  })
                  .catch(() => {
                    this.fillChartDataIob()
                    this.sortTime(this.chartData)
                    setTimeout(() => {
                      if (this.mixPlot) {
                        this.mixPlot.changeData(this.chartData)
                      }
                      resolve()
                    }, 300)
                  })
              })
            })
          })
        })
      },
      getChart() {
        // const data = this.removeDuplicates(this.chartData, 'create_time')
        const data = this.chartData
        console.log(data, 'data')

        this.mixPlot = new Mix('container1', {
          appendPadding: 8,
          padding: [0, 0, 60, 20],
          syncViewPadding: true,
          slider: {
            start: this.chartTime,
            end: 1,
            height: 30,
            textStyle: {
              fillOpacity: 0,
            },
            trendCfg: {
              lineStyle: {
                stroke: '#5b8ff9',
                lineWidth: 2,
                lineDash: [4, 5],
                strokeOpacity: 0.7,
                shadowColor: '#5b8ff9',
                shadowBlur: 10,
                shadowOffsetX: 5,
                shadowOffsetY: 5,
                cursor: 'pointer',
              },
            },
            handlerStyle: {
              width: 0,
              height: 0,
              opacity: 0,
            },
          },
          data,
          tooltip: {
            showTitle: false,
            crosshairs: {
              type: 'x',
              follow: true,
            },
            interactions: [{ type: 'tooltip' }],
            position: 'top',
            customContent: (title, data) => this.renderPointTooltip(title, data),
          },
          meta: {
            time: {
              type: 'timeCat',
              mask: 'YYYY-MM-DD HH:mm:ss', // 原始数据的精度,让xAxis能访问到秒级数据
            },
          },
          supportCSSTransform: true,

          plots: [
            {
              type: 'scatter',
              top: true,
              options: {
                xField: 'create_time',
                yField: 'v',
                // size: this.chartTime == 0.875 ? 4 : this.chartTime == 0.75 || this.chartTime == 0.5 ? 3 : 2,
                shape: 'circle',
                pointStyle: {
                  stroke: null, // 移除边框
                  fillOpacity: 1, // 填充不透明
                },
                sizeField: 'type',
                size: ({ type }) => {
                  if (type != 'sugar') {
                    return 0
                  } else {
                    return this.chartTime == 0.875 ? 3 : this.chartTime == 0.75 ? 2.5 : this.chartTime == 0.5 ? 2 : 1.5
                  }
                },
                colorField: 'v',
                color: ({ v }) => {
                  return v > this.targetHigh
                    ? '#F4664A'
                    : v > this.targetLow
                    ? '#6395fa'
                    : v > 0 && v != 2
                    ? '#ffaa29'
                    : '#ffff'
                },
                // 隐藏颜色控件图例
                legend: {
                  visible: false,
                },
                supportCSSTransform: true,
                yAxis: {
                  line: null,
                  tickMethod: () => [0, 5, 10, 15, 20, 25],
                },
                label: {
                  offsetY: 0,
                  content: item => {
                    this.loopType = item.json ? JSON.parse(item.json).type : ''
                    if (item.type == 'kfy') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/yaowu.png'),
                        },
                      })
                      // group.addShape({
                      //   type: 'text',
                      //   attrs: {
                      //     x: 6,
                      //     y: 2,
                      //     text: item.type,
                      //     textAlign: 'center',
                      //     textBaseline: 'top',
                      //     fill: '#000'
                      //   }
                      // })
                      return group
                    } else if (item.type == 'ts') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/tanshui.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'yds') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/yidaosu.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'yd') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/yundong.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'zx') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/xuetang.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'xy' || item.type == 'aolXy') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/bloodPress.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'xz') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/bloodZhi.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'ns') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/niaosuan.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'GLU' || item.type == 'aolXt') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/xuetang.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'UA') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/niaosuan.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'BF') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/bloodZhi.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'KET') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 0,
                          y: 12,
                          width: 10,
                          height: 10,
                          img: require('@/static/pic/xt.png'),
                        },
                      })
                      return group
                    } else if (item.type == 'Correction Bolus') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 2,
                          y: 16,
                          width: 1 * item.insulin < 1 ? 6 : 6 + 3 * item.insulin,
                          height: 1 * item.insulin < 1 ? 6 : 6 + 3 * item.insulin,
                          img: item.isLongActingInsulin ? require('@/static/pic/ydsns.png') : yds,
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: 1 * item.insulin < 5 ? 6 : 14,
                          y: 1 * item.insulin < 1 ? 22 : 1 * item.insulin < 6 ? 6 : 0,
                          fontSize: 1 * item.insulin < 1 ? 8 : 8 + 1.5 * item.insulin,
                          text: (item.insulin * 1).toFixed(1) + 'U',
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: 1 * item.insulin > 1 ? '#000' : '#424242',
                        },
                      })
                      const comboNote = item.notes !== 'null' ? item.notes : ''
                      if (comboNote) {
                        group.addShape({
                          type: 'text',
                          attrs: {
                            x: 1 * item.insulin < 5 ? 6 : 14,
                            y: 1 * item.insulin < 1 ? 22 : 1 * item.insulin < 6 ? 6 : 0,
                            fontSize: 1 * item.insulin < 1 ? 8 : 8 + 1.5 * item.insulin,
                            text: comboNote,
                            textAlign: 'center',
                            textBaseline: 'bottom',
                            fill: '#000',
                          },
                        })
                      }
                      return group
                    } else if (item.type == 'Combo Bolus') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 2,
                          y: 16,
                          width: 1 * item.insulin < 1 ? 6 : 6 + 3 * item.insulin,
                          height: 1 * item.insulin < 1 ? 6 : 6 + 3 * item.insulin,
                          img: item.isLongActingInsulin ? require('@/static/pic/ydsns.png') : yds,
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: 1 * item.insulin < 5 ? 6 : 14,
                          y: 1 * item.insulin < 1 ? 22 : 1 * item.insulin < 6 ? 6 : 0,
                          fontSize: 1 * item.insulin < 1 ? 8 : 8 + 1.5 * item.insulin,
                          text: (item.insulin * 1).toFixed(1) + 'U',
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: 1 * item.insulin > 1 ? '#000' : '#424242',
                        },
                      })
                      const comboNote = item.notes !== 'null' ? item.notes : ''
                      if (comboNote) {
                        group.addShape({
                          type: 'text',
                          attrs: {
                            x: 1 * item.insulin < 5 ? 6 : 14,
                            y: 1 * item.insulin < 1 ? 22 : 1 * item.insulin < 6 ? 6 : 0,
                            fontSize: 1 * item.insulin < 1 ? 8 : 8 + 1.5 * item.insulin,
                            text: comboNote,
                            textAlign: 'center',
                            textBaseline: 'bottom',
                            fill: '#000',
                          },
                        })
                      }
                      return group
                    } else if (item.type == 'Carb Correction') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x: 8,
                          y: 22,
                          width: this.chartTime == 0 ? 7 : this.chartTime == 0.5 ? 8 : 9,
                          height: this.chartTime == 0 ? 7 : this.chartTime == 0.5 ? 8 : 9,
                          img: require('@/static/pic/tstr.png'),
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x: 12,
                          y: 27,
                          fontSize: this.chartTime == 0.875 || this.chartTime == 0.75 ? 8 : 6,
                          text: item.carbs + 'g',
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: '#424242',
                        },
                      })
                      return group
                    } else if (item.type == 'Temporary Override') {
                      const group = new G.Group({})
                      group.addShape({
                        type: 'image',
                        attrs: {
                          x:
                            this.chartTime == 0.875
                              ? item.duration * 3
                              : this.chartTime == 0.75
                              ? (item.duration * 3) / 2
                              : this.chartTime == 0.5
                              ? (item.duration * 1.5) / 2
                              : ((item.duration / 4) * 3) / 2,
                          y: 12,
                          width:
                            this.chartTime == 0.875
                              ? item.duration * 6
                              : this.chartTime == 0.75
                              ? item.duration * 3
                              : this.chartTime == 0.5
                              ? item.duration * 1.5
                              : (item.duration / 4) * 3,
                          height: 12,
                          img: require('@/static/pic/override.png'),
                        },
                      })
                      group.addShape({
                        type: 'text',
                        attrs: {
                          x:
                            this.chartTime == 0.875
                              ? item.duration * 3 + 18
                              : this.chartTime == 0.75
                              ? (item.duration * 3) / 2 + 18
                              : this.chartTime == 0.5
                              ? (item.duration * 1.5) / 2 + 18
                              : ((item.duration / 4) * 3) / 2 + 18,
                          y: 12,
                          fontSize: 8,
                          text: item.reason,
                          textAlign: 'center',
                          textBaseline: 'top',
                          fill: '#000',
                        },
                      })
                      return group
                    }
                    // else if (item.type == 'Suspend Pump') {
                    //   const group = new G.Group({})
                    //   group.addShape({
                    //     type: 'image',
                    //     attrs: {
                    //       x: 0,
                    //       y: 10,
                    //       width: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 11 : 13,
                    //       height: this.chartTime == 0 ? 9 : this.chartTime == 0.5 ? 11 : 13,
                    //       img: require('@/static/pic/pump.png'),
                    //     },
                    //   })
                    //   return group
                    // }
                  },
                  labelLine: true,
                },
                annotations: [
                  {
                    type: 'region',
                    start: ['min', this.targetLow],
                    end: ['max', this.targetHigh],
                    style: {
                      stroke: '#edf0f2',
                      lineDash: [2, 2],
                    },
                  },

                  {
                    type: 'text',
                    position: ['min', this.targetHigh],
                    content: this.targetHigh,
                    style: {
                      fill: '#F4664A',
                    },
                  },

                  {
                    type: 'text',
                    position: ['min', this.targetLow],
                    content: this.targetLow,
                    style: {
                      fill: '#ffaa29',
                    },
                  },
                  // {
                  //   type: 'regionFilter',
                  //   start: ['min', 0],
                  //   end: ['max', 3.9],
                  //   color: '#ffaa29',
                  // },
                  // {
                  //   type: 'regionFilter',
                  //   start: ['min', 10],
                  //   end: ['max', 20],
                  //   color: '#F4664A',
                  // },
                ],
              },
            },
            {
              type: 'line',
              top: true,
              options: {
                xField: 'create_time',
                yField: 'tempValue',
                stepType: 'vh',
                connectNulls: true,
                lineStyle: {
                  lineWidth: 1,
                },
                tooltip: {
                  showTitle: false,
                  crosshairs: {
                    type: 'x',
                    follow: true,
                  },
                  interactions: [{ type: 'tooltip' }],
                  position: 'top',
                  customContent: (title, data) => {
                    title = title ? this.$moment(title).format('HH:mm:ss') : null
                    let loopType = title ? (data[0].data.json ? JSON.parse(data[0].data.json).type : '') : ''
                    let type = ''
                    let eventType = title ? data[0].data.type : ''
                    let res = title ? data[0].data : ''
                    let parse = title ? (data[0].data.json ? JSON.parse(data[0].data.json) : '') : ''
                    if (title && data[0].data.v == 2) {
                      return null
                    } else {
                      if (title && data[0].data.type === 'zx') {
                        type = '指尖血'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 场景：${res.eventValue}</div>` : ''}
                        <div style="margin-bottom:4px;">指血指数：${res.way}mmol/L</div>
                      </div>`
                      } else if (title && data[0].data.type === 'kfy') {
                        type = '口服药'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 药名：${res.way}</div>
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 用药量：${res.eventValue}mg</div>` : ''}
                      </div>`
                      } else if (title && data[0].data.type === 'aolXy') {
                        type = '爱奥乐血压'
                        const heartRate = res.data3
                          ? `<div style="margin-bottom:2px;font-size:10px;"> 心率：${res.data3}次/分</div>`
                          : ''
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 高压：${res.data1 || '--'}mmHg</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 低压：${res.data2 || '--'}mmHg</div>
                        ${heartRate}
                      </div>`
                      } else if (title && data[0].data.type === 'xy') {
                        type = '血压'
                        const heartRate =
                          res.scene && res.scene !== '--'
                            ? `<div style="margin-bottom:2px;font-size:10px;"> 心率：${res.scene}次/分</div>`
                            : ''
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 收缩压：${res.way || '--'}mmHg</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 舒张压：${res.eventValue || '--'}mmHg</div>
                        ${heartRate}
                      </div>`
                      } else if (title && data[0].data.type === 'xz') {
                        type = '血脂'
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 总胆固醇：${res.way || '--'}mmol/L</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 甘油三酯：${res.eventValue || '--'}mmol/L</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 低密度脂蛋白：${res.scene || '--'}mmol/L</div>
                      </div>`
                      } else if (title && data[0].data.type === 'ns') {
                        type = '尿酸'
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 尿酸值：${res.way || '--'}umol/L</div>
                      </div>`
                      } else if (title && data[0].data.type === 'aolXt') {
                        type = '爱奥乐血糖'
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 血糖值：${res.value || '--'}mmol/L</div>
                      </div>`
                      } else if (title && data[0].data.type === 'GLU') {
                        type = '血糖'
                        return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 血糖值：${res.value || '--'}mmol/L</div>
                        </div>`
                      } else if (title && data[0].data.type === 'UA') {
                        type = '尿酸'
                        return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 尿酸值：${res.value || '--'}umol/L</div>
                        </div>`
                      } else if (title && data[0].data.type === 'KET') {
                        type = '血酮'
                        return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 血酮值：${res.value || '--'}mmol/L</div>
                        </div>`
                      } else if (title && data[0].data.type === 'BF') {
                        type = '血脂'
                        return `<div style="padding:2px;">
                          <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 总胆TC：${res.TC || '--'}mmol/L</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 甘油TG：${res.TG || '--'}mmol/L</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 高密HDL：${res.HDL || '--'}mmol/L</div>
                          <div style="margin-bottom:2px;font-size:10px;"> 低密LDL：${res.LDL || '--'}mmol/L</div>
                        </div>`
                      } else if (title && data[0].data.type === 'ts') {
                        type = '碳水'
                        const imgDom = res.img
                          ? `<div style="margin-top:4px;text-align:center;">
                              <img src="${res.img}" style="width:120px;height:120px;object-fit:cover;border-radius:4px;" />
                            </div>`
                          : ''
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> ${res.eventValue}</div>
                        <div style="margin-bottom:4px;"> 碳水化合物：${res.way}g</div>
                        ${imgDom}
                      </div>`
                      } else if (title && data[0].data.type === 'yds') {
                        type = '胰岛素'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 注射剂量：${res.way}U</div>
                        ${res.scene ? `<div style="margin-bottom:4px;"> 注射时段：${res.scene}</div>` : ''}
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 胰岛素名称：${res.eventValue}</div>` : ''}
                      </div>`
                      } else if (title && data[0].data.type === 'yd') {
                        type = '运动'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 运动项目：${res.way}</div>
                        ${res.scene ? `<div style="margin-bottom:4px;"> 运动时长：${res.scene}分钟</div>` : ''}
                        ${res.eventValue ? `<div style="margin-bottom:4px;"> 消耗：${res.eventValue}kcal</div>` : ''}
                      </div>`
                      } else if (title && loopType == 1) {
                        type = '关闭闭环'
                      } else if (title && loopType == 2) {
                        type = '开启闭环'
                      } else if (title && loopType == 3) {
                        type = '覆盖方波'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 持续时间：${parse.minutes}</div>
                        <div style="margin-bottom:4px;"> 原因：${parse.fugainame}</div>
                      </div>`
                      } else if (title && loopType == 4) {
                        type = '取消方波'
                      } else if (title && loopType == 5) {
                        type = '添加碳水'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 总量：${parse.carbs}g</div>
                        <div style="margin-bottom:4px;"> 吸收时间：${parse.carbsHouers}h</div>
                      </div>`
                      } else if (title && loopType == 6) {
                        type = '大剂量'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 剂量：${parse.bolus}U</div>
                      </div>`
                      } else if (title && loopType == 7) {
                        type = '临时基础率'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 临时基础率：${parse.perHour}U/h</div>
                        <div style="margin-bottom:4px;"> 持续时间：${parse.baseHouers}h</div>
                      </div>`
                      } else if (title && loopType == 8) {
                        type = '取消临时'
                      } else if (title && eventType == 'Correction Bolus') {
                        type = '胰岛素'
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 剂量：${(res.insulin * 1).toFixed(2)}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 名称：${res.insulinType || '无'}</div>
                      </div>`
                      } else if (title && eventType == 'Combo Bolus') {
                        type = '扩展胰岛素'
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> ${title}</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 剂量：${(res.insulin * 1).toFixed(2)}U</div>
                        <div style="margin-bottom:2px;font-size:10px;"> 持续时间：${res.duration || '无'}分钟</div>
                      </div>`
                      } else if (title && eventType == 'Carb Correction') {
                        type = '碳水'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 克数：${res.carbs ? res.carbs + 'g' : '无'}</div>
                        <div style="margin-bottom:4px;"> 类型：${res.foodType ? res.foodType : '无'}</div>
                      </div>`
                      } else if (title && eventType == 'Temporary Override') {
                        type = '覆盖方波'
                        return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div style="margin-bottom:4px;"> ${title}</div>
                        <div style="margin-bottom:4px;"> 需求比例：${
                          res.insulinNeedsScaleFactor ? res.insulinNeedsScaleFactor : '无'
                        }</div>
                        <div style="margin-bottom:4px;"> 持续时间：${res.duration}分钟</div>
                        <div style="margin-bottom:4px;"> 原因：${res.reason}</div>
                      </div>`
                      } else if (title && eventType == 'Suspend Pump') {
                        type = '泵'
                      } else if (title && eventType == 'sugar') {
                        type = '血糖'
                        return `<div style="padding:2px;">
                        <div style="font-size:10px;font-weight: 700;margin-bottom:2px;">${type}:${(
                          data[0].data.v * 1
                        ).toFixed(1)}</div>
                        <div style="margin-bottom:2px;font-size:10px"> 基础率:${
                          data[0].data.tempValue
                            ? data[0].data.tempValue.toFixed(2)
                            : data[0].data.tempValue == 0
                            ? 0
                            : '无'
                        }</div>
                        <div style="margin-bottom:2px;font-size:10px"> ${title}</div>

                      </div>`
                      } else {
                        type = '其他'
                      }
                      return `<div style="padding:4px;">
                        <div style="font-size:14px;font-weight: 700;margin-bottom:4px;">${type}</div>
                        <div> ${title}</div>
                      </div>`
                    }
                  },
                },
                yAxis: {
                  min: 0,
                  max: this.maxTemp * 5.6,
                  label: null,
                  grid: null,
                  // tickMethod: () => [ 1, 2, 3],
                },
                xAxis: {
                  label: {
                    formatter: text => {
                      return this.$moment(text).format('HH:mm') // 只想展示到秒？
                    },
                  },
                },
              },
            },
            {
              type: 'line',
              top: true,
              options: {
                xField: 'create_time',
                yField: 'iob',
                color: '#009944',
                connectNulls: true,
                lineStyle: {
                  lineWidth: 0,
                },
                area: {
                  smooth: true,
                  style: {
                    fill: '#1890ff',
                    fillOpacity: 0.3,
                  },
                },
                xAxis: {
                  label: {
                    formatter: text => {
                      return this.$moment(text).format('HH:mm')
                    },
                  },
                },
                yAxis: {
                  min: 0,
                  max: this.maxIob ? this.maxIob * 4 : 4,
                  label: null,
                  grid: null,
                },
                tooltip: {
                  showTitle: false,
                  crosshairs: {
                    type: 'x',
                    follow: true,
                  },
                  interactions: [{ type: 'tooltip' }],
                  position: 'top',
                },
              },
            },
          ],
        })
        this.mixPlot.render()

        if (this.loopRemote && data.length) {
          this.$emit('getTemp', data[data.length - 1].tempValue, data[data.length - 1].tempType)
        }

        this.mixPlot.on('slider:mousemove', (...args) => {
          this.handleMove(args[0])
        })

        this.mixPlot.on('plot:mousemove', event => {
          const { x } = event
          const elements = this.mixPlot.chart.geometries[0].elements
          let closestElement = null
          let minDistance = Infinity

          elements.forEach(element => {
            const bbox = element.shape.getCanvasBBox()
            const elementX = (bbox.minX + bbox.maxX) / 2
            const distance = Math.abs(x - elementX)

            if (distance < minDistance) {
              minDistance = distance
              closestElement = element
            }
          })

          if (closestElement) {
            this.mixPlot.chart.showTooltip({
              x: (closestElement.shape.getCanvasBBox().minX + closestElement.shape.getCanvasBBox().maxX) / 2,
              y: (closestElement.shape.getCanvasBBox().minY + closestElement.shape.getCanvasBBox().maxY) / 2,
            })
          } else {
            this.mixPlot.chart.hideTooltip()
          }
        })

        // 点击/触摸开始：当前最近点策略（x、y综合）
        const showNearestTooltip = event => {
          const { x, y } = event
          // 获取点图中的所有数据点
          const elements = this.mixPlot.chart.geometries[0].elements
          let closestElement = null
          let minDistance = Infinity

          elements.forEach(element => {
            const bbox = element.shape.getCanvasBBox()
            const elementX = (bbox.minX + bbox.maxX) / 2
            const elementY = (bbox.minY + bbox.maxY) / 2
            const distance = Math.hypot(x - elementX, y - elementY)

            if (distance < minDistance) {
              minDistance = distance
              closestElement = element
            }
          })

          if (closestElement) {
            const bbox = closestElement.shape.getCanvasBBox()
            this.mixPlot.chart.showTooltip({
              x: (bbox.minX + bbox.maxX) / 2,
              y: (bbox.minY + bbox.maxY) / 2,
            })
          } else {
            this.mixPlot.chart.hideTooltip()
          }
        }

        // 移动时：使用仅按 x 距离最近的点（原有逻辑）
        this.mixPlot.on('plot:touchmove', event => {
          const { x } = event
          const elements = this.mixPlot.chart.geometries[0].elements
          let closestElement = null
          let minDistance = Infinity

          elements.forEach(element => {
            const bbox = element.shape.getCanvasBBox()
            const elementX = (bbox.minX + bbox.maxX) / 2
            const distance = Math.abs(x - elementX)

            if (distance < minDistance) {
              minDistance = distance
              closestElement = element
            }
          })

          if (closestElement) {
            const bbox = closestElement.shape.getCanvasBBox()
            this.mixPlot.chart.showTooltip({
              x: (bbox.minX + bbox.maxX) / 2,
              y: (bbox.minY + bbox.maxY) / 2,
            })
          } else {
            this.mixPlot.chart.hideTooltip()
          }
        })
        this.mixPlot.on('plot:touchstart', showNearestTooltip)
        this.mixPlot.on('plot:click', showNearestTooltip)

        // 确保触摸移出图表时隐藏 tooltip
        this.mixPlot.on('plot:mouseup', () => {
          this.mixPlot.chart.hideTooltip()
        })
        this.mixPlot.on('plot:touchend', () => {
          this.mixPlot.chart.hideTooltip()
        })
      },

      getData() {
        return new Promise(resolve => {
          this.chartData = []
          const params = {
            id: this.userId,
            end: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
            start: this.$moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
          }

          getSugerbyId(params).then(res => {
            if (res.data.data && res.data.data.length) {
              res.data.data.forEach(item => {
                this.chartData.push({
                  create_time: item.create_time,
                  v: item.v,
                  tooltip_time: item.create_time.substring(11, 16),
                  type: 'sugar',
                })
              })

              const result = []
              const FIVE_MINUTES = 5 * 60 * 1000 // 5分钟
              const TEN_MINUTES = 10 * 60 * 1000 // 10分钟
              const ONE_DAY = 23 * 60 * 60 * 1000 // 24小时

              if (this.chartData.length === 0) {
                console.error('chartData 数组为空')
                return
              }

              // 当前时间
              const currentTime = Date.now()
              let firstTime = this.parseTime(this.chartData[0].create_time)
              let lastTime = this.parseTime(this.chartData[this.chartData.length - 1].create_time)

              // 确保时间跨度覆盖到当前时间的 24 小时
              if (currentTime - firstTime < ONE_DAY) {
                // 在头部补充数据
                while (firstTime > currentTime - ONE_DAY) {
                  firstTime -= FIVE_MINUTES
                  result.unshift({
                    create_time: this.formatTime(firstTime),
                    v: 2,
                    type: 'sugar',
                    tooltip_time: this.formatTime(firstTime).substring(11, 16),
                  })
                }
              }

              // 遍历原始数据并补全中间的缺失数据
              for (let i = 0; i < this.chartData.length - 1; i++) {
                result.push(this.chartData[i])
                let currentTime = this.parseTime(this.chartData[i].create_time)
                const nextTime = this.parseTime(this.chartData[i + 1].create_time)

                // 如果相差大于 10 分钟，则补充两个 5 分钟的数据点
                while (nextTime - currentTime > TEN_MINUTES) {
                  // currentTime += FIVE_MINUTES
                  // result.push({
                  //   create_time: this.formatTime(currentTime),
                  //   v: 2,
                  //   type: 'sugar',
                  //   tooltip_time: this.formatTime(currentTime).substring(11, 16),
                  // })
                  currentTime += FIVE_MINUTES
                  result.push({
                    create_time: this.formatTime(currentTime),
                    v: 2,
                    type: 'sugar',
                    tooltip_time: this.formatTime(currentTime).substring(11, 16),
                  })
                }

                // 如果间隔大于 5 分钟且小于 10 分钟，则补充一个数据点
                // while (nextTime - currentTime > FIVE_MINUTES) {
                //   currentTime += FIVE_MINUTES
                //   result.push({
                //     create_time: this.formatTime(currentTime),
                //     v: 2,
                //     type: 'sugar',
                //     tooltip_time: this.formatTime(currentTime).substring(11, 16),
                //   })
                // }
              }

              // 添加最后一项数据
              result.push(this.chartData[this.chartData.length - 1])

              // 添加最后一个数据点
              result.push(this.chartData[this.chartData.length - 1])

              // **补充最后一个数据点到当前时间**
              while (currentTime - lastTime > TEN_MINUTES) {
                lastTime += FIVE_MINUTES
                result.push({
                  create_time: this.formatTime(lastTime),
                  v: 2,
                  type: 'sugar',
                  tooltip_time: this.formatTime(lastTime).substring(11, 16),
                })
              }

              this.chartData = result

              const emitArr = this.removeDuplicates(res.data.data, 'create_time')
              const length = emitArr.length

              if (length > 1) {
                const leftV = emitArr[length - 1].v - emitArr[length - 2].v
                if (emitArr[length - 1].v > emitArr[length - 2].v) {
                  this.trend = leftV > 0.5 ? 3 : 1 // 3是极速上升  1是缓步上升
                } else if (emitArr[length - 1].v < emitArr[length - 2].v) {
                  this.trend = leftV > 0.5 ? 4 : 2 // 4是极速下降  2是缓步下降
                } else {
                  this.trend = 0
                }
                const leftSugar = (emitArr[length - 1].v - emitArr[length - 2].v).toFixed(1)
                const lastTime = emitArr[length - 1].create_time
                this.$emit('getTrend', this.trend, emitArr[length - 1].v, leftSugar, lastTime)
              }
            } else {
              this.isHaveSugar = false
            }

            resolve()
          })
        })
      },

      // 拖动 slider 回调
      handleMove: debounce(function (e) {
        const geometries = e && e.view && e.view.geometries
        const viewData = geometries && geometries[0] && geometries[0].data
        if (!viewData || !viewData.length) return
        const lastData = viewData[viewData.length - 1]
        this.$emit('getTemp', lastData.tempValue, lastData.tempType)
        const createTime = this.$moment(lastData.create_time).add(1, 'minutes').format('YYYY-MM-DD HH:mm:ss')
        const params = {
          uid: this.userId,
          create_time: createTime,
          type: this.loopRemote,
        }
        const sugarParams = {
          id: this.userId,
          end: createTime,
          start: this.$moment().subtract(23, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        }
        getSugerbyId(sugarParams).then(res => {
          if (res.data.data && res.data.data.length) {
            const emitArr = this.removeDuplicates(res.data.data, 'create_time')
            const length = emitArr.length

            if (length > 1) {
              const leftV = emitArr[length - 1].v - emitArr[length - 2].v
              if (emitArr[length - 1].v > emitArr[length - 2].v) {
                this.trend = leftV > 0.5 ? 3 : 1
              } else if (emitArr[length - 1].v < emitArr[length - 2].v) {
                this.trend = leftV > 0.5 ? 4 : 2
              } else {
                this.trend = 0
              }
              const leftSugar = (emitArr[length - 1].v - emitArr[length - 2].v).toFixed(1)
              const lastTime = emitArr[length - 1].create_time
              this.$emit('getTrend', this.trend, emitArr[length - 1].v, leftSugar, lastTime)
            }
          }
        })
        loopHistory(params).then(res => {
          this.$emit('loopInfo', res)
        })
      }, 300),
    },

    computed: {
      maxTime() {
        const nextTime = this.$moment()
          .add(1 + this.timerNum - this.timerNum, 'hours')
          .format('YYYY-MM-DD HH:00:00')
        return new Date(nextTime).getTime()
      },
      minTime3() {
        const min = this.$moment()
          .subtract(2 + this.timerNum - this.timerNum, 'hours')
          .format('YYYY-MM-DD HH:00:00')
        return new Date(min).getTime()
      },
      minTime6() {
        const min = this.$moment()
          .subtract(5 + this.timerNum - this.timerNum, 'hours')
          .format('YYYY-MM-DD HH:00:00')
        return new Date(min).getTime()
      },
      minTime12() {
        const min = this.$moment()
          .subtract(11 + this.timerNum - this.timerNum, 'hours')
          .format('YYYY-MM-DD HH:00:00')
        return new Date(min).getTime()
      },
      minTime24() {
        const min = this.$moment()
          .subtract(23 + this.timerNum - this.timerNum, 'hours')
          .format('YYYY-MM-DD HH:00:00')
        return new Date(min).getTime()
      },
    },

    watch: {
      // 每10秒自动渲染一次chart2，要先清除
      timerNum: {
        handler: function (newVal, oldVal) {
          this.$nextTick(() => {
            this.getData()
          })
        },
      },

      btnNum: {
        handler: function (newVal, oldVal) {
          this.chartTime = newVal
          this.sliderStart = this.chartTime
          this.sliderEnd = 1
          if (this.chartTime == 0.875) {
            this.minTime = this.minTime3
            this.tickInterval = 30 * 60 * 1000
          } else if (this.chartTime == 0.75) {
            this.minTime = this.minTime6
            this.tickInterval = 60 * 60 * 1000
          } else if (this.chartTime == 0.5) {
            this.minTime = this.minTime12
            this.tickInterval = 2 * 60 * 60 * 1000
          } else if (this.chartTime == 0) {
            this.minTime = this.minTime24
            this.tickInterval = 4 * 60 * 60 * 1000
          }
          this.$nextTick(() => {
            this.mixPlot.destroy()
            this.getChart()
          })
          const params = {
            id: this.userId,
            end: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
            start: this.$moment().subtract(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
          }
          getSugerbyId(params).then(res => {
            const length1 = res.data.data.length
            if (res.data.data && length1) {
              const emitArr = this.removeDuplicates(res.data.data, 'create_time')
              const length = emitArr.length

              if (length > 1) {
                const leftV = emitArr[length - 1].v - emitArr[length - 2].v
                if (emitArr[length - 1].v > emitArr[length - 2].v) {
                  this.trend = leftV > 0.5 ? 3 : 1 // 3是极速上升  1是缓步上升
                } else if (emitArr[length - 1].v < emitArr[length - 2].v) {
                  this.trend = leftV > 0.5 ? 4 : 2 // 4是极速下降  2是缓步下降
                } else {
                  this.trend = 0
                }
                const leftSugar = (emitArr[length - 1].v - emitArr[length - 2].v).toFixed(1)
                const lastTime = emitArr[length - 1].create_time
                this.$emit('getTrend', this.trend, emitArr[length - 1].v, leftSugar, lastTime)
              }
              const create_time = res.data.data[length1 - 1].create_time
              let params1 = {
                uid: this.userId,
                create_time: this.$moment().add(1, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
                type: this.loopRemote,
              }
              loopHistory(params1).then(res => {
                this.$emit('loopInfo', res)
              })
            }
          })
        },
      },

      alarmType: {
        handler: function (newVal, oldVal) {
          this.$nextTick(() => {
            const nowTime = this.$moment().format('YYYY-MM-DD HH')
            if (this.patientInfo.playTime.substring(0, 10) == this.$moment().format('YYYY-MM-DD')) {
              if (
                (Number(this.patientInfo.bloodSugar) > this.patientInfo.target_high ||
                  Number(this.patientInfo.bloodSugar) < this.patientInfo.target_low) &&
                this.patientInfo.playTime == nowTime &&
                newVal == true
              ) {
                this.alarmBlink = true
                this.startplay()
              } else {
                this.alarmBlink = false
                this.pausePlay()
              }
            } else {
              if (
                (Number(this.patientInfo.bloodSugar) > this.patientInfo.target_high ||
                  Number(this.patientInfo.bloodSugar) < this.patientInfo.target_low) &&
                newVal == true
              ) {
                this.alarmBlink = true
                this.startplay()
              } else {
                this.alarmBlink = false
                this.pausePlay()
              }
            }
          })
        },
        deep: true,
      },

      // isAlarm: {
      //   handler: function (newVal, oldVal) {
      //     this.isAlarm1 = this.isAlarm
      //   },
      // },

      isAlarm: {
        handler: function (newVal, oldVal) {
          if (newVal) {
            this.$refs.play.click()
          } else {
            this.$refs.stop.click()
          }
        },
      },
    },
  }
</script>

<style scoped lang="less">
  .common-box {
    height: 100%;
    overflow: hidden;
    touch-action: none;
  }
</style>
